import React from 'react';
import MediaQueries from 'react-responsive';

import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Link from 'gatsby-link';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

import assets from 'marketing-website/configs/pages/developers/assets';

import generalStyles from './style/general.module.css';

export default function Showcase() {
  return (
    <Spacing size="l" sizeM="xl" position="topBottom" type="padding">
      <PageWrap>
        <Grid columns={2}>
          <GridItem columnSpan={2} columnSpanM={1}>
            <MediaQueries maxWidth={769}>
              <Image {...assets.showcase} hasShadow={false} maxWidth={600} />
            </MediaQueries>
            <HeadingBlock
              color="white"
              title="Showcase your app in our integrations directory"
              copy="Building something special? We’re always looking to work with partners who want to help the world bring their ideas to life."
              maxWidth={500}
            >
              <div className={generalStyles.buttons}>
                <div className={generalStyles.margin}>
                  <a
                    href="https://marvelapp.typeform.com/to/tT0fpS"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Button
                      size="large"
                      shape="rounded"
                      color="slate"
                      hover="white"
                      background="white"
                    >
                      Become a partner
                    </Button>
                  </a>
                </div>
                <Link to="/features/integrations">
                  <Button
                    size="large"
                    shape="rounded"
                    kind="ghost"
                    hover="white"
                    isReversed
                  >
                    View Integrations
                  </Button>
                </Link>
              </div>
            </HeadingBlock>
          </GridItem>
          <GridItem>
            <MediaQueries minWidth={770}>
              <Image {...assets.showcase} hasShadow={false} maxWidth={600} />
            </MediaQueries>
          </GridItem>
        </Grid>
      </PageWrap>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/developers/Showcase.js